import React from 'react'
import { Box, Typography, withStyles } from '@material-ui/core'
import styles from './styles'

const logos = Array.from({ length: 23 }, (_, i) => 23 - i)

const TrustedBy = ({ classes }) => {
  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>
        Trusted by over 20,000+ training providers
      </Typography>
      <div className={classes.marqueeContainer}>
        <style>
          {`
            @keyframes marqueeScroll {
              from { transform: translateX(0); }
              to { transform: translateX(-100%); }
            }
          `}
        </style>
        <div className={classes.marqueeContent}>
          <div className={classes.marqueeGroup}>
            {logos.map((logo, index) => (
              <Box
                component="img"
                key={index}
                src={`/assets/login-logos/${logo}.svg`}
                alt={`logo-${logo}`}
                style={{ height: 50, width: 114, objectFit: 'contain' }}
              />
            ))}
          </div>
          <div className={classes.marqueeGroup} aria-hidden="true">
            {logos.map((logo, index) => (
              <Box
                component="img"
                key={index}
                src={`/assets/login-logos/${logo}.svg`}
                alt={`logo-${logo}`}
                style={{ height: 50, width: 114, objectFit: 'contain' }}
              />
            ))}
          </div>
        </div>
      </div>
    </Box>
  )
}

export default withStyles(styles)(TrustedBy)
